import { Injectable, inject } from '@angular/core';
import { AsyncValidator, AbstractControl, ValidationErrors } from '@angular/forms';
import { UserService } from '@api';
import { Observable, of, timer } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServerEmailValidator implements AsyncValidator {
  private userService = inject(UserService);

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return timer(500).pipe(
      switchMap(() =>
        this.userService.userCheckEmailAddressRetrieve({ emailAddress: this.filterEmailAddress(control.value) }).pipe(
          map((): null => null),
          catchError(() => of({ email: true }))
        )
      )
    );
  }

  private filterEmailAddress(value: unknown): string {
    if (typeof value !== 'string') {
      return '';
    }

    return value;
  }
}
